// @ts-nocheck

import { Block } from "@xprog/prensa"

import * as S from '../styles'

const PopularPageTeam = () => {
  return (
    <S.MainDiv>
      <S.Heading1>Expediente</S.Heading1>
      <Block css={S.logoProps}>
        <img src='/assets/opopular/logos/LogoGrupoJaimeCamara.svg' alt='Logo Grupo Jaime Câmara' height='32px' width='110px' />
      </Block>
      <Block css={S.topBlockProps}>
        <Block css={S.itemTopProps}>
          <S.Heading2>FUNDADOR:</S.Heading2>
          <S.Heading3>Jaime Câmara (1909 - 1989)</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>VICE-PRESIDENTE DE NEGÓCIOS:</S.Heading2>
          <S.Heading3>Ronaldo Borges Ferrante</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>PRESIDENTE:</S.Heading2>
          <S.Heading3>Jaime Câmara Júnior</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>CEO:</S.Heading2>
          <S.Heading3>Breno Machado</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>DIR. JURÍDICO/ REL. INSTITUCIONAIS:</S.Heading2>
          <S.Heading3>Guliver Augusto Leão</S.Heading3>
        </Block>
      </Block>
      <Block css={S.logo2Props}>
        <img src="/assets/daqui/logos/LogoDaquiDesktop.svg" alt="Logo Jornal Daqui" height="67px" width="118px" />
      </Block>
      <Block css={S.middleBlockProps}>
        <Block css={S.itemMiddleProps}>
          <S.Heading2>FUNDADORES:</S.Heading2>
          <S.Heading4>Jaime Câmara (1909 - 1989)</S.Heading4>
          <S.Heading4>Joaquim Câmara Filho (1899 - 1955)</S.Heading4>
          <S.Heading4>Rebouças Câmara (1898 - 1973)</S.Heading4>
        </Block>
        <Block css={S.itemMiddleProps}>
          <S.Heading2>DIRETOR SUPERINTENDENTE:</S.Heading2>
          <S.Heading4>Tasso José Câmara</S.Heading4>
        </Block>
        <Block css={S.itemMiddleProps}>
          <S.Heading2>EDITORES EXECUTIVOS:</S.Heading2>
          <S.Heading4>Luciano Martins</S.Heading4>
        </Block>
      </Block>
      <Block css={S.middleBlockProps}>
        <Block css={S.itemMiddleProps}>
          <S.Heading2>GERENTE DE CONTEÚDO DIGITAL:</S.Heading2>
          <S.Heading5>Elisângela Nascimento</S.Heading5>
        </Block>
        <Block css={S.itemMiddleProps}>
          <S.Heading2>EDITORES ONLINE:</S.Heading2>
          <S.Heading5>Ivânia Cavalcanti</S.Heading5>
          <S.Heading5>Pedro Nunes</S.Heading5>
        </Block>
        <Block css={S.itemMiddleProps}>
          <S.Heading2>REPRESENTANTE:</S.Heading2>
          <S.Heading4>Rio de Janeiro: 21 2524 5644</S.Heading4>
          <S.Heading4>Belo Horizonte: 31 2535 2711 / 8865 7363</S.Heading4>
          <S.Heading4>Vitória: 27 2124 9739 / 99762 4151</S.Heading4>
        </Block>
      </Block>
      <Block css={S.middleBlockProps}>
        <Block css={S.itemMiddleProps}>
          <S.Heading2>CENTRAL DE COMERCIALIZAÇÃO:</S.Heading2>
          <S.Heading5>Rua Thomas Edson - Quadra 7</S.Heading5>
          <S.Heading5>nº 500 - Setor Serrinha</S.Heading5>
          <S.Heading5>Tel.: 62 3250 1215 | Fax: 62 3250 1260</S.Heading5>
        </Block>
        <Block css={S.itemMiddleProps}>
          <S.Heading2>SUCURSAL SÃO PAULO:</S.Heading2>
          <S.Heading5>Rua Álvaro Anes - nº 56, Conjunto 72</S.Heading5>
          <S.Heading5>Bairro Pinheiros, São Paulo - SP</S.Heading5>
          <S.Heading5>Tel./fax: 11 3775-8100</S.Heading5>
        </Block>
        <Block css={S.itemMiddleProps}>
          <S.Heading2>SUCURSAL BRASÍLIA:</S.Heading2>
          <S.Heading5>SBS, Edifício OK - Office Tower</S.Heading5>
          <S.Heading5>7º andar, Salas 712/715</S.Heading5>
          <S.Heading5>Tel.: 61 3321 0501</S.Heading5>
        </Block>
      </Block>
      <Block css={S.bottomBlockProps}>
        <Block css={S.itemBottomProps}>
          <S.Heading2>PUBLICIDADE:</S.Heading2>
          <S.Heading4>(62) 3250-1453</S.Heading4>
        </Block>
      </Block>
    </S.MainDiv>
  )
}

export default PopularPageTeam
